import axios from 'axios';

// "Link personalizados" del portal de empresa (lisual-admin-backend, /api/links-personalizados/:customerId).
// En local se apunta a un backend propio con REACT_APP_LINKS_API_URL (los links quedan en un JSON de la PC).
const BASE = (process.env.REACT_APP_LINKS_API_URL || process.env.REACT_APP_BACKEND_URL || 'http://localhost:8081').replace(/\/$/, '');
const api = axios.create({ baseURL: `${BASE}/api/links-personalizados`, timeout: 20000 });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authLisualToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const errorLinks = (e) => {
  if (e?.response?.data?.message) return e.response.data.message;
  if (e?.code === 'ECONNABORTED') return 'El servidor tardó demasiado en responder. Probá de nuevo.';
  if (e?.request && !e?.response) return 'No pudimos conectarnos. Revisá tu conexión y probá de nuevo.';
  return e?.message || 'Algo salió mal';
};

const c = (customerId) => `/${encodeURIComponent(customerId)}`;

export const getLinks = async (customerId) => (await api.get(c(customerId))).data;
export const crearLink = async (customerId, { nombre, url }) => (await api.post(c(customerId), { nombre, url })).data;
export const editarLink = async (customerId, linkId, cambios) => (await api.put(`${c(customerId)}/${encodeURIComponent(linkId)}`, cambios)).data;
export const borrarLink = async (customerId, linkId) => (await api.delete(`${c(customerId)}/${encodeURIComponent(linkId)}`)).data;
export const ordenarLinks = async (customerId, ids) => (await api.put(`${c(customerId)}/orden`, { ids })).data;
export const verificarLink = async (customerId, linkId) => (await api.post(`${c(customerId)}/${encodeURIComponent(linkId)}/verificar`)).data;
